import React from "react";

import BooleanSelector from "./BooleanSelector";

export default function AllowNullBCvSelector(props) {
  return <BooleanSelector label="Permitir código Cruz Verde nulo" {...props} />;
}
